// Utility to validate the company code, address lines, and zip code.
export const validateFormInputs = (formData) => {
	const { companyCode, addressLine1, zipCode, hasTaxExclusion } = formData;

	// Only validate for non-international (non-tax-exempt) companies
	if (!hasTaxExclusion) {
		if (!companyCode || companyCode.trim() === "") {
			return { isValid: false, message: "Company code is required." };
		}

		if (!addressLine1 || addressLine1.trim() === "") {
			return { isValid: false, message: "Address Line 1 is required." };
		}

		if (!zipCode || zipCode.trim() === "") {
			return { isValid: false, message: "Zip Code is required." };
		}

		if (hasTaxExclusion === null || hasTaxExclusion === undefined) {
			return { isValid: false, message: "Invalid tax exclusion value." };
		}
	}

	return { isValid: true };
};
